export enum FreeKickAttribute {
  DangerousFreeKick = 466,
}
